import { render, staticRenderFns } from "./consultationform.vue?vue&type=template&id=328fc371&scoped=true&"
import script from "./consultationform.vue?vue&type=script&lang=js&"
export * from "./consultationform.vue?vue&type=script&lang=js&"
import style0 from "./consultationform.vue?vue&type=style&index=0&id=328fc371&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328fc371",
  null
  
)

export default component.exports